<template>
  <div class="stepsdemo-content">
    <Teleport to="body">
      <div v-if="isCompletingContract" class="contract-navigation-blocker" aria-busy="true" aria-label="Apertura nuovo caricamento" />
    </Teleport>
    <Card v-if="!loading">
      <template v-slot:title>
        <div class="grid">
          <p class="m-0 col-12 text-center" style="color:transparent">Carica Punti di Prelievo</p>

          <TutorialDialog :slides="slides" :window-size="windowSize" />
        </div>
      </template>
      <template v-slot:content>
        <div class="box-option flex flex-wrap justify-content-center">
          <h3 class="m-2 col-12 flex justify-content-center">
            <strong>Opzioni contratto</strong>
          </h3>
          <div class="w-full flex flex-wrap justify-content-between">
            <!-- Selezione type spedizione -->
            <div class="col-12 xl:col-2 text-center box-option" v-if="can_select_spedizione">
              <label class="m-3"><strong>Tipologia di spedizione</strong></label>
              <div v-for="spedizione in spedizioni" :key="spedizione.key ?? spedizione.id ?? spedizione.name" class="col-12 flex flex-column p-0">
                <div class="flex m-2">
                  <RadioButton v-model="selectedSpedizione" :inputId="`spedizione-${spedizione.key ?? spedizione.id ?? spedizione.name}`" :value="spedizione.name" :disabled="isSpedizioneCartaceaDisabled(spedizione)" />
                  <label :for="`spedizione-${spedizione.key ?? spedizione.id ?? spedizione.name}`" :class="['ml-2', {'text-color-secondary': isSpedizioneCartaceaDisabled(spedizione)}]">{{ spedizione.name }}</label>
                </div>
              </div>
            </div>
            <!-- Selezione frequenza -->
            <div class="col-12 xl:col-2 text-center box-option" v-if="can_select_bimestrale">
              <label class="m-3"><strong>Frequenza di fatturazione</strong></label>
              <div v-for="frequenza in frequenze" :key="frequenza.key" class="col-12 flex flex-column p-0">
                <div class="flex m-2">
                  <RadioButton v-model="selectedFrequenza" :inputId="frequenza.key" :value="frequenza.name"/>
                  <label :for="frequenza.key" class="ml-2">{{ frequenza.name }}</label>
                </div>
              </div>
            </div>
            <!-- Selezione IVA agevolata -->
            <div class="col-12 xl:col-2 text-center box-option" v-if="can_select_iva">
              <label class="m-3"><strong>Iva Agevolata Energia</strong></label>
              <div class="m-3">
                <Checkbox v-model="isIvaAgevolata" :binary="true"/>
              </div>
            </div>
            <!-- Selezione data switch -->
            <div class="col-12 xl:col-2 text-center box-option" v-if="can_select_data_switch">
              <label class="m-3"><strong>Data switch</strong></label>
              <div class="m-3 flex justify-content-center">
                <Calendar v-model="dataSwitch" :minDate="minDataSwitch" :maxDate="maxDataSwitch" view="month" dateFormat="mm/yy" style="width:6rem" :manualInput="false"/>
              </div>

              <!-- <div class="m-3">
                <Checkbox id="isCheckedDataSwitch" v-model="isCheckedDataSwitch" :binary="true"/>
                <label for="isCheckedDataSwitch" class="m-3">Prima data utile</label>
              </div>
  
              <div v-show="!isCheckedDataSwitch">
                <div class="mb-1">
                  <label for="pod" class="m-3">Pod:</label>
                  <Calendar v-model="dataSwitchPod" :minDate="minDatePod" :maxDate="maxDatePod" view="month" dateFormat="mm/yy" style="width:6rem" :manualInput="false"/>
                </div>
                <div>
                  <label for="pod" class="m-3">Pdr:</label>
                  <Calendar v-model="dataSwitchPdr" :minDate="minDatePdr" :maxDate="maxDatePdr" view="month" dateFormat="mm/yy" style="width:6rem" :manualInput="false"/>
                </div>
              </div> -->
            </div>
            <!-- Selezione promo -->
            <div class="col-12 xl:col-2 text-center box-option" v-if="canViewInputPromo && selectedAgent">
              <label class="m-3"><strong>Codice promozionale</strong></label>
              <div class="flex flex-wrap align-items-center justify-content-center">
                <InputText v-model="codice_promozionale" type="text" class="m-3" v-on:keydown.enter="verificaCodicePromozionale()" @input="checkCanGoToNext($event)" @blur="verificaCodicePromozionale(false)"/>
                <Button v-show="canViewButtonCheckCodicePromozionale" icon="pi pi-check" v-tooltip="`Verifica codice promozionale`" @click="verificaCodicePromozionale()"/>
              </div>
              <div class="flex flex-column justify-content-center col-4 align-items-center">
              </div>
            </div>
            <!-- Selezione contratto manuale -->
            <div class="col-12 xl:col-2 text-center box-option" v-if="can_sign_manual">
              <label class="m-3"><strong>Contratto cartaceo</strong></label>
              <div class="m-3">
                <Checkbox v-model="isManualContract" :binary="true" @change="onChangeIsManualContract()"/>
              </div>
              <div v-if="isManualContract" class="mt-3 grid justify-content-center">
                <div class="flex align-items-center">
                  <label class="w-full">Data firma:</label>
                  <Calendar v-model="data_firma_cartaceo" :maxDate="maxDate" :manualInput="false" dateFormat="dd/mm/yy" @update:modelValue="onChangeDataFirma" class="m-2"/>
                  <div v-show="validationErrors.data_firma_cartaceo && submitted" class="p-error">Campo richiesto.</div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="isSpedizioneCartacea" class="w-full mt-3 px-3 pb-3">
            <div class="shipping-address-panel">
              <InlineMessage severity="info" class="w-full justify-content-start">
                La verifica dell'indirizzo di contatto è richiesta perché nella tipologia di spedizione selezionata è presente l'opzione Cartaceo.
              </InlineMessage>
              <div class="shipping-address-copy">
                <div class="text-sm font-bold mb-1">Indirizzo di spedizione</div>
                <div class="text-sm line-height-3">
                  {{ indirizzoContattoSpedizioneLabel || 'Indirizzo di contatto non presente' }}
                </div>
              </div>
              <div class="shipping-address-actions">
                <Button label="Valida indirizzo" icon="pi pi-check" class="p-button-sm" :loading="validazioneIndirizzoSpedizione.loading" :disabled="!hasIndirizzoContattoSpedizione || validazioneIndirizzoSpedizione.loading" @click="validaIndirizzoSpedizione"/>
                <Button v-if="validazioneIndirizzoSpedizione.called && validazioneIndirizzoSpedizione.status === false" label="Modifica indirizzo" icon="pi pi-pencil" class="p-button-sm p-button-warning" @click="openDialogIndirizzoSpedizione"/>
              </div>
              <div v-if="validazioneIndirizzoSpedizione.called" class="w-full mt-2">
                <InlineMessage v-if="validazioneIndirizzoSpedizione.status === true" severity="success" class="w-full justify-content-start">
                  {{ validazioneIndirizzoSpedizione.message }}
                </InlineMessage>
                <InlineMessage v-if="validazioneIndirizzoSpedizione.status === false" :severity="canBlockAddressValidation ? 'error' : 'warn'" class="w-full justify-content-start">
                  {{ shippingAddressValidationMessage }}
                </InlineMessage>
              </div>
            </div>
          </div>
        </div>
        <div class="box-option p-2">
          <h3 class="m-2 col-12 flex justify-content-center">
            <strong>Documenti</strong>
          </h3>
          <div v-if="requiredDocuments.length == 0" class="m-2 col-12 flex flex-column align-items-center">
            Nessun documento necessario. Procedi alla generazione del contratto
          </div>
          <div v-else class="m-2 col-12 flex flex-column align-items-center">
            Documenti necessari:
            <li v-for="label in labels" :key="label"><strong>{{ label }}</strong></li>
            <small>Formati consentiti: {{allowedType.join(", ")}}</small>
          </div>
          <div v-if="requiredDocuments.length > 0" class="flex flex-wrap justify-content-center">
            <div v-for="(document, index) in requiredDocuments" :key="document.name" class="col-12 sm:col-10 md:col-7 lg:col-3 xl:col-2">
              <div v-if="document.already_imported.length" class="col-12">
                File già caricati:
                <div v-for="(already_imported, index_already_imported) in document.already_imported" :key="index_already_imported" style="height: 40px" class="flex">
                  <p>{{already_imported}}</p>
                  <Button v-if="document.ref == 'gen'" v-tooltip="`Elimina altri file`" @click="document.delete_gen = true" icon="pi pi-trash" class="col-1 p-button-rounded p-button-text p-button-danger"/>
                </div>
              </div>
              <div class="flex">
                <div v-if="document.ref == 'gen'" class="col-1"></div>
                <div :class="['flex flex-column align-items-center mb-3 justify-content-center', document.ref == 'gen' ? 'col-10' : 'col-12']">
                  <div class="button-wrapper mb-2">
                    <span class="p-1 label flex align-items-center justify-content-center">Carica {{document.name}}</span>
                    <input class="upload-file" :name="`${document.ref}`" type="file" :ref="document.ref" @change="handleFileNewUpload($event, document)" accept="application/pdf,image/gif,image/jpeg,image/jpg,image/png" :multiple="document.multiple" :disabled="isDisableInput"/>
                  </div>
                  <div>
                    <p class="text-center">
                      File selezionati:
                    </p>
                    <ul>
                      <li v-for="file in document.files" :key="file.name">{{ file.name }}</li>
                    </ul>
                  </div>
                  <div v-show="validationErrors[`${document.ref}`] && submitted" class="p-error">Campo richiesto.</div>
                  <div v-show="validationErrors[`type_${document.ref}`] && submitted" class="p-error">Formato non consentito</div>
                </div>
                <Button v-if="document.ref == 'gen'" v-tooltip="`Elimina altri file`" @click="deleteFile(index)" icon="pi pi-trash" class="col-1 p-button-rounded p-button-text p-button-danger"/>
              </div>
            </div>
            <div v-if="isVisibleAddFile">
              <Button v-tooltip="`Aggiungi file`" @click="addFile()" icon="pi pi-plus" class="p-button-rounded p-button-text p-button-success" />
            </div>
          </div>
        </div>
        <div class="flex flex-column align-items-center box-option" v-if="can_insert_note">
          <h3 class="m-2 col-12 flex justify-content-center">
            <strong>Note</strong>
          </h3>
          <Textarea style="width: 95%;" v-model="note" variant="filled" rows="5" cols="30" class="m-2"/>
        </div>
      </template>
      <template v-slot:footer>
        <div class="grid justify-content-between">
          <Button label="Indietro" @click="prevPage()" icon="pi pi-angle-left" iconPos="left" class="p-btn-footer card-primary btn-reset"/>
          <div class="flex flex-column gap-2">
            <InlineMessage v-if="canGoToRiepilogo.disabled" severity="warn" class="w-full justify-content-start">
              {{ canGoToRiepilogo.message }}
            </InlineMessage>

            <Button label="Genera Contratto" icon="pi pi-file-pdf" v-if="!canGoToRiepilogo.disabled" @click="confirmSubmission()" class="card-primary btn-reset"/>
          </div>
        </div>
      </template>
    </Card>
    <Dialog v-model:visible="showDialogIndirizzoSpedizione" header="Modifica indirizzo di spedizione" :style="{ width: '45rem' }" modal :draggable="false">
      <div class="grid p-fluid">
        <div class="col-12 md:col-4">
          <label for="spedizione_toponimo">Toponimo</label>
          <Dropdown id="spedizione_toponimo" v-model="indirizzoSpedizioneEdit.toponimo" :options="toponimi" optionLabel="name" optionValue="name" :filter="true" placeholder="Seleziona toponimo" class="inputfield w-full" @change="onChangeIndirizzoSpedizioneEdit"/>
        </div>
        <div class="col-12 md:col-6">
          <label for="spedizione_indirizzo">Indirizzo</label>
          <InputText id="spedizione_indirizzo" v-model="indirizzoSpedizioneEdit.indirizzo" @input="onChangeIndirizzoSpedizioneEdit"/>
        </div>
        <div class="col-12 md:col-2">
          <label for="spedizione_civico">Civico</label>
          <InputText id="spedizione_civico" v-model="indirizzoSpedizioneEdit.civico" @input="onChangeIndirizzoSpedizioneEdit"/>
        </div>
        <div class="col-12 md:col-3">
          <label for="spedizione_cap">Cap</label>
          <InputText id="spedizione_cap" v-model="indirizzoSpedizioneEdit.cap" @input="onChangeIndirizzoSpedizioneEdit"/>
        </div>
        <div class="col-12 md:col-4">
          <label for="spedizione_provincia">Provincia</label>
          <Dropdown id="spedizione_provincia" v-model="indirizzoSpedizioneEdit.provincia" :options="province" optionLabel="name" optionValue="code" :filter="true" placeholder="Seleziona provincia" class="inputfield w-full" @change="onSelectedProvinciaIndirizzoSpedizione"/>
        </div>
        <div class="col-12 md:col-5">
          <label for="spedizione_comune">Comune</label>
          <Dropdown id="spedizione_comune" v-model="indirizzoSpedizioneEdit.cod_comune" :options="cities_indirizzo_spedizione" optionLabel="name" optionValue="id" :filter="true" placeholder="Seleziona comune" class="inputfield w-full" @change="onSelectedComuneIndirizzoSpedizione"/>
        </div>
      </div>
      <template #footer>
        <Button label="Annulla" icon="pi pi-times" text @click="showDialogIndirizzoSpedizione = false"/>
        <Button label="Salva indirizzo" icon="pi pi-check" class="p-button-success" :disabled="!canSaveIndirizzoSpedizione" @click="saveIndirizzoSpedizione"/>
      </template>
    </Dialog>
    <Dialog v-model:visible="showConfirm" header="Riepilogo Caricamento" :style="{ width: '70%' }" modal>
      <h3>Nuovo contratto con {{props.formData.nome_pratica}}</h3>
      <div class="grid p-fluid" v-if="props.formData">
        <div class="col-12">
          <div class="grid">
            <div v-if="hasClienteData" class="col-12 md:col-6">
              <Panel header="Intestatario Contratto" class="h-full shadow-1">
                <div class="text-xl font-bold text-900">
                  {{ props.formData.cliente?.ragsoc || (props.formData.cliente?.nome + ' ' + props.formData.cliente?.cognome) }}
                </div>
                <div class="text-600">CF/PIVA: {{ props.formData.cliente?.piva || props.formData.cliente?.codfis }}</div>
                <div class="mt-2 text-sm text-500">
                  Sede: {{ props.formData.cliente?.toponimo }} {{ props.formData.cliente?.indirizzo }} {{ props.formData.cliente?.civico }}
                </div>
              </Panel>
            </div>
            
            <div :class="hasClienteData ? 'col-12 md:col-6' : 'col-12'">
              <Panel class="h-full shadow-1 border-left-3" :class="isManualContract ? 'border-gray-600' : 'border-yellow-500'">
                <template #header>
                  <div class="flex align-items-center gap-2">
                    <i :class="isManualContract ? 'pi pi-print' : 'pi pi-tablet'"></i>
                    <span class="font-bold ml-2">Modalità di Firma</span>
                  </div>
                </template>
                
                <div class="flex align-items-center justify-content-between mb-3">
                  <div class="flex gap-2">
                    <Tag v-if="isManualContract" severity="secondary" value="CARTACEO / MANUALE" icon="pi pi-file-pdf" />
                    <Tag v-else severity="warning" value="FIRMA DIGITALE (OTP)" icon="pi pi-send" />
                    
                    <Tag v-if="props.formData.rappresentante" severity="info" value="Rappresentante" />
                  </div>
                </div>
                
                <div class="text-xl font-bold mb-3" :class="isManualContract ? 'text-700' : 'text-primary'">
                  {{ props.formData.rappresentante?.name || (props.formData.cliente?.nome + ' ' + props.formData.cliente?.cognome) }}
                </div>
                
                <div class="grid p-2 border-round" :class="{'surface-100': isManualContract, 'bg-yellow-50': !isManualContract}">
                  <div class="col-12 md:col-6 flex align-items-center gap-2">
                    <i class="pi pi-envelope text-500 mr-2"></i>
                    <span :class="{'font-bold': !isManualContract}">{{ contattoSpedizione?.email }}</span>
                  </div>
                  <div class="col-12 md:col-6 flex align-items-center gap-2">
                    <i class="pi pi-phone text-500 mr-2"></i>
                    <span :class="{'font-bold': !isManualContract}">{{ contattoSpedizione?.cellulare ?? contattoSpedizione?.cell}}</span>
                  </div>
                  <div v-if="contattoSpedizione?.pec || contattoSpedizione?.bypass_pec?.value" class="col-12 md:col-6 flex align-items-center gap-2">
                    <i class="pi pi-envelope text-500 mr-2"></i>
                    <div class="flex flex-column">
                      <span v-if="contattoSpedizione?.pec" :class="{'font-bold': !isManualContract}"><strong>PEC:</strong> {{ contattoSpedizione.pec }}</span>
                      <span v-if="contattoSpedizione?.bypass_pec?.value" class="p-error">
                        <strong>Bypass PEC:</strong> {{ contattoSpedizione.bypass_pec.reason }}
                      </span>
                    </div>
                  </div>
                </div>
                <small v-if="isManualContract" class="block mt-2 text-500 italic">
                  * La pratica verrà generata per la firma autografa e dovrà essere caricata manualmente.
                </small>
              </Panel>
            </div>
          </div>
        </div>

        <div v-if="note" class="col-12 mt-2">
          <Panel header="Note della Pratica" class="shadow-1 border-left-3 border-orange-400">
            <div class="white-space-pre-line text-800 line-height-3">
              <i class="pi pi-info-circle mr-2 text-orange-500"></i>
              {{ note }}
            </div>
          </Panel>
        </div>
        
        <div class="col-12 mt-3">
          <h3 class="ml-2 mb-3 text-900 font-bold">Dettaglio Punti di Fornitura</h3>
          
          <div v-for="(row, idx) in props.formData.manualRows" :key="idx" class="mb-4 border-round border-1 border-300 shadow-2 overflow-hidden surface-card">
            <div class="bg-gray-100 p-3 border-bottom-1 border-300 flex justify-content-between align-items-center">
              <div class="flex align-items-center gap-2">
                <i class="pi pi-building text-700 mr-2"></i>
                <span class="font-bold text-lg text-800">{{ row.RAGIONE_SOCIALE }}</span>
              </div>
              <div class="text-sm font-bold text-600">CF: {{ row.CODICE_FISCALE_PIVA }}</div>
            </div>
            
            <div class="grid grid-nogutter align-items-stretch">
              <div class="col-12 md:col-4 p-4">
                <div class="flex align-items-center gap-3 mb-3">
                  <i :class="row.TIPO === 'pod' ? 'pi pi-bolt text-yellow-600' : 'pi pi-flame text-orange-600'" style="font-size: 1.8rem"></i>
                  <div>
                    <span class="block text-xl font-bold text-900">{{ row.POD_PDR }}</span>
                    <Tag :value="row.TIPO.toUpperCase()" :severity="row.TIPO === 'pod' ? 'info' : 'warning'" class="mr-2" />
                    <span class="text-xs font-bold text-500 uppercase">{{ row.USO }}</span>
                  </div>
                </div>
                <div class="text-sm text-600 line-height-3">
                  {{ row.TOPONIMO_FORNITURA }} {{ row.INDIRIZZO_FORNITURA }} {{ row.CIVICO_FORNITURA }}<br>
                  {{ row.CAP_FORNITURA }} - {{ row.CITTA_FORNITURA }} ({{ row.SIGLA_PROVINCIA_FORNITURA }})
                </div>
                <br>
                <div class="text-sm text-600 line-height-3">
                  Pagamento con {{row.IBAN ? `Addebito SDD su iban `+row.IBAN : 'bollettino postale'}}
                  <br>
                  {{ !row.checked_data_iban_equal_to_client ? '' : `${row.INTESTAZIONE_IBAN} - ${row.CODICE_FISCALE_PIVA_IBAN}` }}
                </div>
              </div>
              
              <div class="col-12 md:col-4 p-4 surface-50 border-left-1 border-right-1 border-200" v-if="row.TIPO === 'pdr'">
                <div class="text-xs font-bold text-500 uppercase mb-3 border-bottom-1 border-200 pb-1">Parametri Tecnici</div>
                <div class="grid grid-nogutter row-gap-3">
                  <div class="col-6">Matricola:<br><span class="font-bold">{{ row.MATRICOLA || 'N/D' }}</span></div>
                  <div class="col-6">Classe:<br><span class="font-bold">{{ row.CLASSE_MISURATORE?.classe || 'N/D' }}</span></div>
                  <div class="col-6">Uso:<br><span class="font-bold text-xs">{{ row.DESTINAZIONE_USO?.name || 'N/D' }}</span></div>
                  <div class="col-6">Consumo:<br><span class="font-bold">{{ row.CONSUMO_ANNUO }} Smc</span></div>
                </div>
              </div>
              
              <div class="col-12 md:col-4" v-else></div>
              
              <div class="col-12 md:col-4 p-4 flex flex-column justify-content-center align-items-center bg-blue-50">
                <div class="text-center">
                  <span class="text-xs font-bold text-blue-600 uppercase block mb-2">Offerta Selezionata</span>
                  <div class="text-xl font-bold text-blue-900 line-height-2">{{ getOffertaName(row.OFFERTA) }}</div>
                  <div class="mt-3 py-1 px-3 border-round bg-white text-primary font-bold text-sm shadow-1">
                    <i class="pi pi-refresh mr-2"></i>{{ row.FREQUENZA }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <Button label="Annulla" icon="pi pi-times" text @click="showConfirm = false" class="p-btn-footer"/>
        <Button label="Conferma caricamento" @click="nextPage()" icon="pi pi-angle-right" iconPos="right" class="p-btn-footer" :disabled="submitted"/>
      </template>
    </Dialog>
    
    <ContractPreviewDialog :show-generated-message="true" ref="contractPreviewDialog" v-model:visible="showModal" :documents="pdfPreviews" :matrice-id="matrice_id" :desktop="windowSize >= 1200" :can-sign="can_require_esign" :manual="isManualContract" @signed="goToFirstStep()" @draft="goToFirstStep()" @edit="updateContratto" @download="showPdf(matrice_id)" />
  </div>
</template>

<script>
import TutorialDialog from './TutorialDialog.vue'
import {ref, getCurrentInstance, onMounted, onActivated, onDeactivated, onBeforeUnmount, computed, watch, nextTick} from 'vue';
import ContractPreviewDialog from './ContractPreviewDialog.vue'
import Service from '@/services/ask-pratiche/pratiche-wizard'   
import Card from 'primevue/card';
import Button from 'primevue/button';
import PraticheWizardBozzeService from '@/services/ask-pratiche/pratiche-wizard-bozze'
import { useToast } from "primevue/usetoast";
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex'
import moment from 'moment';
import Opzioni from '@/config/opzioni'

export default {
  components: { ContractPreviewDialog, TutorialDialog },
  props: {
    formData: Object
  },
  emits: [
    'activeLoader', 
    'activeLoaderCaricamento', 
    'prev-page', 
    'next-page', 
    'complete'
  ],
  setup (props, {emit}) {
    const store = useStore()
    const currentUser = ref()
    const loading = ref(true)
    const route = useRoute()
    const toast = useToast();
    const files = ref([])
    const cartaceo = ref([])
    const di = ref([])
    const ft = ref([])
    const vs = ref([])
    const ctr = ref([])
    const is_pratica = ref(props.formData.pratica == null ? false : true)
    const pratica = ref()
    const router = useRouter()

    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const praticheWizardBozzeService = new PraticheWizardBozzeService(self.$eventBus)
    const opzioni = new Opzioni()
    const toponimi = opzioni.toponimi
    const province = opzioni.province
    const stepIndex = 3
    const allowedType = ['pdf','jpeg','jpg','png']
    const validationErrors = ref({})
    const submitted = ref(false)
    const showModal = ref(false)
    const contractPreviewHidden = ref(false)
    const isCompletingContract = ref(false)
    onDeactivated(() => { isCompletingContract.value = false })
    const matrice_id = ref('');
    const pdfPreviews = ref([])
    const contractDownloaded = ref(false)
    const pdfPreviewLoading = ref(false)
    const signatureRequested = ref(false)
    const signatureLoading = ref(false)
    let pdfPreviewVersion = 0
    const clearPdfPreview = () => {
      pdfPreviewVersion++
      pdfPreviews.value = []
      pdfPreviewLoading.value = false
    }
    onBeforeUnmount(clearPdfPreview)
    const isNavigatingToStepInfo = ref(false)
    let returnToFirstStepTimer = null
    let completionRequested = false
    const contractPreviewDialog = ref(null)
    let closingAnimationVersion = 0
    const clearClosingAnimation = () => { closingAnimationVersion++ }
    const clearReturnToFirstStepTimer = () => {
      clearTimeout(returnToFirstStepTimer)
      returnToFirstStepTimer = null
    }
    onDeactivated(clearReturnToFirstStepTimer)
    onBeforeUnmount(clearReturnToFirstStepTimer)
    const note = ref('');
    const isDisableShowPdf = ref(false);
    const isDisableSignPdf = ref(false);
    const can_require_esign = ref(false)
    const isDisableInput = ref(false)
    const windowSize = ref(window.innerWidth)

    const typeClient = ref('');
    const is_complete_rapp = ref(true);
    const data_firma_cartaceo = ref()
    const maxDate = new Date()
    const forceDisableGeneraContratto = ref(false)

    const canGoToRiepilogo = computed(() => {
      const required = requiredDocuments.value;
      
      // Risultato di default
      const res = {
        disabled: false,
        message: ""
      };

      // if (!required || required.length === 0) {
      //   return { disabled: true, message: "Nessun documento richiesto configurato." };
      // }

      // Identifichiamo i documenti mancanti
      const missingDocs = required.filter(doc => {
        const hasFiles = doc.files && doc.files.length > 0;
        const hasImported = doc.already_imported && doc.already_imported.length > 0;
        return !hasFiles && !hasImported;
      });

      // Se ci sono documenti mancanti, disabilitiamo e generiamo il messaggio
      if (missingDocs.length > 0) {
        res.disabled = true;
        
        if (missingDocs.length === 1) {
          res.message = `Manca il documento obbligatorio: ${missingDocs[0].name || 'Documento senza nome'}`;
        } else if (missingDocs.length === required.length) {
          res.message = "Caricare tutti i documenti obbligatori per generare il contratto.";
        } else {
          res.message = `Mancano ancora ${missingDocs.length} documenti obbligatori.`;
        }
      }

      if (isSpedizioneCartacea.value) {
        if (!hasIndirizzoContattoSpedizione.value) {
          return {
            disabled: true,
            message: 'Indirizzo di spedizione non presente o incompleto.'
          }
        }

        if (!validazioneIndirizzoSpedizione.value.called) {
          return {
            disabled: true,
            message: 'Valida l\'indirizzo di spedizione prima di generare il contratto.'
          }
        }

        if (validazioneIndirizzoSpedizione.value.status === false && can_block_address.value) {
          return {
            disabled: true,
            message: validazioneIndirizzoSpedizione.value.error || 'Indirizzo di spedizione non valido.'
          }
        }
      }

      return res;
    });

    const requiredDocuments = ref([])
    const slides = ref([])
    const showConfirm = ref(false);
    const labels = ref([])
    const can_sign_manual = ref()
    const can_insert_note = ref()
    const can_select_frequenza = ref()
    const can_select_data_switch = ref()
    const can_select_bimestrale = ref()
    const can_select_spedizione = ref()
    const can_select_iva = ref()
    const can_block_address = ref()

    const normalizeBooleanDefaultTrue = (value) => {
      if (value === undefined || value === null || value === '') return true

      return Boolean(Number(value))
    }

    const isFtCartaceaEnabledForSelectedOfferte = () => {
      const offerte = Array.isArray(props.formData.offerte) ? props.formData.offerte : []
      const rows = Array.isArray(props.formData.manualRows) ? props.formData.manualRows : []

      return rows.every(row => {
        const selectedOfferta = row.OFFERTA
        const selectedOffertaId = selectedOfferta && typeof selectedOfferta === 'object'
          ? selectedOfferta.id
          : selectedOfferta

        const offerta = offerte.find(item => String(item.id) === String(selectedOffertaId))

        return !offerta || normalizeBooleanDefaultTrue(offerta.can_select_ft_cartacea)
      })
    }

    const isSpedizioneCartaceaDisabled = (spedizione) => {
      return (spedizione?.name || '').includes('Cartaceo') && !isFtCartaceaEnabledForSelectedOfferte()
    }

    const applyFtCartaceaAvailability = () => {
      if (isSpedizioneCartaceaDisabled({ name: selectedSpedizione.value })) {
        selectedSpedizione.value = spedizioni.value.find(spedizione => !isSpedizioneCartaceaDisabled(spedizione))?.name || ''
      }
    }

    const getRequiredFields = async () => {
      await service.getRequiredFields({
        cod_admin: currentUser.value.role == 'admin' ? currentUser.value.id : 0,
        cod_agente: props.formData.agente,
        type_client: props.formData.typeClient,
        pps: props.formData.manualRows.map(item => item.POD_PDR),
        cod_cliente: props.formData.cliente?.id ?? 0,
        cod_rapp: props.formData.rappresentante?.id ?? 0,
        pratica: props.formData.pratica
      })
      .then(res => {
        let data = res.res.data
        labels.value = data.labels
        if (data.need_documento) addFile('di')
        if (data.need_fatture) addFile('ft')
        if (data.need_titolo) addFile('tg')
        can_sign_manual.value = data.can_sign_manual
        can_insert_note.value = data.can_insert_note
        can_select_frequenza.value = data.can_select_frequenza
        can_select_data_switch.value = data.can_select_data_switch
        can_select_bimestrale.value = Boolean(data.can_select_bimestrale)
        can_select_iva.value = data.can_select_iva
        can_select_spedizione.value = data.can_select_spedizione
        can_block_address.value = data.can_block_address !== undefined ? Boolean(data.can_block_address) : false
        spedizioni.value = data.spedizioni || [...defaultSpedizioni]
        selectedSpedizione.value = data.selectedSpedizione || data.selected_spedizione || selectedSpedizione.value
        applyFtCartaceaAvailability()
        dataSwitch.value = new Date(moment(data.data_switch)),
        minDataSwitch.value = new Date(moment(data.min_data_switch)),
        maxDataSwitch.value = new Date(moment(data.max_data_switch))
      })
    }
    
    const isStepDocumentiRoute = () => route.path.startsWith('/multisito/step-documenti')
    const hasValidFormData = () => {
      return Boolean(
        props.formData &&
        Object.keys(props.formData).length > 0 &&
        Array.isArray(props.formData.manualRows) &&
        props.formData.typeClient !== undefined &&
        props.formData.agente !== undefined
      )
    }
    const getInitializeKey = () => {
      if (!hasValidFormData()) return ''

      const manualRowsKey = props.formData.manualRows.map(row => row.POD_PDR || '').join('|')
      const contatto = props.formData.contatto || {}
      const contattoKey = [
        contatto.id || '',
        contatto.toponimo || '',
        contatto.indirizzo || '',
        contatto.civico || '',
        contatto.cap || '',
        contatto.provincia || '',
        contatto.cod_comune || '',
        contatto.nome_comune || contatto.name || '',
        contatto.email || '',
        contatto.pec || '',
        contatto.bypass_pec?.value ? 1 : 0,
        contatto.bypass_pec?.reason || '',
        contatto.cell || contatto.cellulare || ''
      ].join('|')

      return [
        route.params.id || 'new',
        props.formData.typeClient || '',
        props.formData.agente || '',
        props.formData.pratica || '',
        props.formData.cliente?.id || props.formData.cliente?.codfis || '',
        props.formData.rappresentante?.id || props.formData.rappresentante?.codfis || '',
        contattoKey,
        manualRowsKey
      ].join('::')
    }
    const initializedKey = ref(null)
    const initializing = ref(false)
    const responsiveInitialized = ref(false)
    const loaderCaricamentoSource = 'step-documenti'
    const setActiveLoaderCaricamento = (active) => {
      emit("activeLoaderCaricamento", {
        active,
        source: loaderCaricamentoSource
      })
    }
    const resetStepDocumentiState = () => {
      isCompletingContract.value = false
      contractPreviewHidden.value = false
      clearReturnToFirstStepTimer()
      completionRequested = false
      clearPdfPreview()
      signatureRequested.value = false
      signatureLoading.value = false
      typeClient.value = props.formData.typeClient
      currentUser.value = store.state.auth.user
      is_pratica.value = props.formData.pratica == null ? false : true
      isCheckedDataSwitch.value = true
      selectedSpedizione.value = spedizioni.value[1].name
      selectedFrequenza.value = 'Mensile'
      pratica.value = pratiche[props.formData.pratica]

      files.value = []
      cartaceo.value = []
      di.value = []
      ft.value = []
      vs.value = []
      ctr.value = []
      requiredDocuments.value = []
      labels.value = []
      slides.value = []
      note.value = ''
      validationErrors.value = {}
      submitted.value = false
      showConfirm.value = false
      showModal.value = false
      forceDisableGeneraContratto.value = false
      isDisableInput.value = false
      isDisableShowPdf.value = false
      isDisableSignPdf.value = false
      can_require_esign.value = false
      is_complete_rapp.value = true
      isManualContract.value = false
      isIvaAgevolata.value = false
      can_block_address.value = false
      data_firma_cartaceo.value = null
      codice_promozionale.value = ''
      id_promozione.value = null
      id_cliente_promozione.value = null
      canGoToNext.value = true

      contattoSpedizioneOriginale.value = getContattoSpedizioneFromProps()
      contattoSpedizione.value = {...contattoSpedizioneOriginale.value}
      indirizzoSpedizioneEdit.value = getIndirizzoSpedizioneEditFromContatto()
      cities_indirizzo_spedizione.value = []
      resetValidazioneIndirizzoSpedizione()
    }
    const initializeStepDocumenti = async () => {
      if (!isStepDocumentiRoute()) return

      if (!hasValidFormData()) {
        loading.value = false
        setActiveLoaderCaricamento(false)
        return
      }

      const initializeKey = getInitializeKey()
      if (initializing.value || (initializedKey.value === initializeKey && !loading.value)) return

      initializing.value = true
      loading.value = true
      setActiveLoaderCaricamento(true)

      try {
        resetStepDocumentiState()
        if (!responsiveInitialized.value) {
          setResponsive()
          responsiveInitialized.value = true
        }

        await Promise.all([
          getSlides(),
          setCanViewInputPromo()
        ])
        await getRequiredFields()

        const hasValidId = route.params.id && route.params.id !== 'null' && route.params.id !== 'undefined';
        if (hasValidId) {
          await getDataMatrice()
        }
        initializedKey.value = initializeKey
      } finally {
        initializing.value = false
        if (loading.value) {
          setActiveLoaderCaricamento(false)
          loading.value = false
        }
      }
    }

    onMounted(() => { service.getContractAnimationsEnabled() })
    onMounted(initializeStepDocumenti)
    onActivated(initializeStepDocumenti)
    watch(
      () => [route.path, getInitializeKey()],
      () => initializeStepDocumenti()
    )
    const updateContratto = async (id) => {
      isNavigatingToStepInfo.value = true
      emit("activeLoader", true)
      try {
        showModal.value = false
        await nextTick()
        await router.push({path: `/multisito/step-info/${id}`, query: {reload: Date.now()}})
      } finally {
        isNavigatingToStepInfo.value = false
        emit("activeLoader", false)
      }
    }
    const setData = (el) => {
      let giorno = el.getDate() 
      let mese = el.getMonth()+1
      mese = mese.toString().padStart(2,'0')
      let anno = el.getFullYear() 
      return `${anno}-${mese}-${giorno}`
    }
    const pratiche = {
      null: null,
      v: 'voltura',
      s: 'subentro',
      ap: 'attivazione preposato'
    }

    const getDataMatrice = async () => {
      await service.getDataMatrice(stepIndex, route.params.id)
      .then((res)=>{
        if (!res.res.data.success) {
          toast.add({severity: 'warn', summary: 'Attenzione', detail: res.res.data.message});
          goToFirstStep()
        }else{
          let data = res.res.data.data

          isIvaAgevolata.value = Boolean(data.isIvaAgevolata)
          isManualContract.value = Boolean(data.is_contratto_manuale)
          selectedSpedizione.value = data.spedizione
          // isCheckedDataSwitch.value = Boolean(data.prima_data_utile)
          // if (!isCheckedDataSwitch.value) {
          //   dataSwitchPod.value = moment(data.data_switch_pod)
          //   dataSwitchPdr.value = moment(data.data_switch_pdr)
          // }
          dataSwitch.value = new Date(moment(data.data_switch_pod))

          data.frequenza = data.frequenza.toLowerCase()
          selectedFrequenza.value = data.frequenza.charAt(0).toUpperCase() + data.frequenza.slice(1)

          Object.keys(data.docs).forEach(code => {
            if (code == 'gen' && !requiredDocuments.value.some(doc => doc.ref == 'gen')) addFile('gen')
            if (code == 'di' && !requiredDocuments.value.some(doc => doc.ref == 'di')) addFile('di')
            data.docs[code].forEach(doc => {
              let index_requiredDocuments = requiredDocuments.value.findIndex(obj_doc => obj_doc.ref == code)
  
              requiredDocuments.value[index_requiredDocuments].already_imported.push(doc.filename)
            });
          })
  
          note.value = data.note
        }
      })
    }

    const setResponsive = () => {
      window.addEventListener('resize', () => {
        windowSize.value = window.innerWidth
      })
    }

    const getSlides = async () => {
      await service.getSlides(stepIndex)
      .then((res) => {
        slides.value = res.items
        slides.value.forEach(slide => {
          slide.name = `/images/Step/step${stepIndex}-${slide.order}.png`
        })
      })
    }


    const onChangeDataFirma = () => {
      delete validationErrors.value.data_firma_cartaceo
    }

    const confirmSubmission = () => {
      showConfirm.value = true;
    };

    const nextPage = async () => {
      submitted.value = true;
      emit("activeLoader", true)

      await validateForm()
      .then((res) => {
        if (res) {
          forceDisableGeneraContratto.value = true
          let fd = new FormData();
          fd.append('matrice_id', JSON.stringify(route.params.id));
          fd.append('data', JSON.stringify(props.formData.manualRows));
          fd.append('type', JSON.stringify(props.formData.type_matrice));
          fd.append('rappresentante', JSON.stringify(props.formData.rappresentante));
          fd.append('is_complete_rapp', JSON.stringify(is_complete_rapp.value));
          fd.append('type_client', JSON.stringify(props.formData.typeClient));
          fd.append('iva', JSON.stringify(isIvaAgevolata.value));
          fd.append('contatto', JSON.stringify(getContattoSpedizionePayload()));
          fd.append('cliente', JSON.stringify(props.formData.cliente));
          fd.append('spedizione', JSON.stringify(selectedSpedizione.value));
          fd.append('contratto_manuale', JSON.stringify(isManualContract.value));
          fd.append('pratica', JSON.stringify(props.formData.pratica));
          fd.append('agente', props.formData.agente);
          fd.append('data_switch', JSON.stringify(moment(dataSwitch.value).format('YYYY-MM-DD')));
          // fd.append('prima_data_utile', JSON.stringify(isCheckedDataSwitch.value));
          // fd.append('data_switch_pod', JSON.stringify(isCheckedDataSwitch.value ? null : setData(dataSwitchPod.value)));
          // fd.append('data_switch_pdr', JSON.stringify(isCheckedDataSwitch.value ? null : setData(dataSwitchPdr.value)));
          fd.append('id_promozione', id_promozione.value);
          fd.append('id_cliente_promozione', id_cliente_promozione.value);
          fd.append('frequenza', JSON.stringify(selectedFrequenza.value));
          fd.append('view', JSON.stringify(props.formData.view));

          let data_firma
          if (data_firma_cartaceo.value) {
            let giorno = data_firma_cartaceo.value.getDate() 
            giorno = giorno.toString().padStart(2,'0')
            let mese = data_firma_cartaceo.value.getMonth()+1
            mese = mese.toString().padStart(2,'0')
            let anno = data_firma_cartaceo.value.getFullYear() 
            data_firma = `${anno}-${mese}-${giorno}`  
          }
          fd.append('data_firma', JSON.stringify(data_firma));
          fd.append('note', JSON.stringify(note.value));
          requiredDocuments.value.forEach((doc)=>{          
            for (let i = 0 ; i < doc.files.length ; i++) {
              fd.append(`${doc.ref}[]`, doc.files[i]); 
            }
          })

          service.saveMultisitoData(fd)
          .then(async (res) => {
            let severity
            let summary = res.item.message
            let detail = `${res.item.totals} righe importate`
            if (res.item.success) {
              matrice_id.value = res.item.matrice_id
              severity = 'success'
              if (isManualContract.value) {
                showConfirm.value = false
                showModal.value = true;
              } else {
                await showPdf(matrice_id.value).then(() => {
                  showConfirm.value = false
                  showModal.value = true;
                })
              }
            } else {
              submitted.value = false;
              severity = 'warn'
              forceDisableGeneraContratto.value = false
              toast.add({severity:severity, summary: summary, detail: detail});
            }
          }).finally(() => {
            emit("activeLoader", false)
            isDisableInput.value = true
          })
        }
      })
    }

    const prevPage = () => {
      emit('prev-page', {
        pageIndex: stepIndex,
        formData: {
          contatto: getContattoSpedizionePayload()
        }
      });
    }

    const goToFirstStep = async (animate = false) => {
      if (completionRequested || isNavigatingToStepInfo.value) return
      completionRequested = true
      isCompletingContract.value = true
      clearReturnToFirstStepTimer()
      const version = closingAnimationVersion
      try {
        if (showModal.value) {
          if (animate) {
            await contractPreviewDialog.value?.finish(animate === 'sent' ? 'signed' : 'draft')
          }
        }
      } finally {
        if (version === closingAnimationVersion) {
          // Unmount the teleported dialog and its mask before cancelling their animations.
          contractPreviewHidden.value = true
          showModal.value = false
          await nextTick()
          if (version === closingAnimationVersion) {
            clearClosingAnimation()
            emit('complete')
          }
        }
      }
    }
  
    const handleFileUpload = (evt, idInput) => {
      if (idInput == 'files') {
        files.value = []
        files.value = self.refs.file1.files;
      } else {
        cartaceo.value = []
        cartaceo.value = self.refs.file2.files;
      }
    };
    const handleFileNewUpload = async (evt, doc) => {
      let can_insert_file = true
      if (!doc.multiple && doc.ref == 'di' && evt.target.files[0].type === 'application/pdf') {
        const file = evt.target.files[0];
        
        const nrPagine = await service.getPdfPageCount(file)
        if (nrPagine > 2) {
          can_insert_file = false
          toast.add({severity:'warn', detail: 'Non è possibile caricare un documento di identità con più di due pagine', life: 5000})
        }
        // const validazione = await service.analyzeDocument(file);
      }
      if (can_insert_file) {
        let index = requiredDocuments.value.findIndex(el => el.ref == doc.ref)
        requiredDocuments.value[index].files = []
        requiredDocuments.value[index].files = self.refs[doc.ref].files
      }

    };

    const showPdf = async (data) => {
      clearPdfPreview()
      contractDownloaded.value = false
      const version = pdfPreviewVersion
      pdfPreviewLoading.value = true
      can_require_esign.value = false
      try {
        if (window.innerWidth < 1200) {
          const downloaded = await service.showPdfMatrice(data)
          if (version !== pdfPreviewVersion) return
          contractDownloaded.value = downloaded === true
          can_require_esign.value = downloaded === true
          return
        }
        const documents = await service.showPdfMatrice(data, true)
        if (version !== pdfPreviewVersion) return
        if (documents && documents.length) {
          pdfPreviews.value = documents
          can_require_esign.value = true
        } else {
          toast.add({severity: 'warn', detail: 'Impossibile caricare l?anteprima PDF. Riprova.'})
        }
      } finally {
        if (version === pdfPreviewVersion) pdfPreviewLoading.value = false
      }
    }

    const signPdf = (data) => {
      if (isDisableSignPdf.value) return
      isDisableSignPdf.value = true
      signatureLoading.value = true
      service.signPdfMatrice(data)
      .then(async (res)=> {
        signatureLoading.value = false
        let severity = res.items.success ? 'success' : 'error'
        let summary = res.items.success ? 'Successo': 'Attenzione'
        let detail = res.items.errore ?? 'Richiesta di firma inviata correttamente'
        
        toast.add({severity:severity, summary: summary, detail:detail});
        if (res.items.success) {
          signatureRequested.value = true
          clearReturnToFirstStepTimer()
          signatureLoading.value = false
          await goToFirstStep('sent')
        }else{
          isDisableSignPdf.value = false
        }
      })
      .finally(()=> {
        emit("activeLoader", false)
      })
    }

    const validateForm = async () => {
      requiredDocuments.value.forEach((doc)=>{
        if (!route.params.id) {
          if (doc.files.length == 0) {
            validationErrors.value[`${doc.ref}`] = true;
            delete validationErrors.value[`type_${doc.ref}`];
          } else {
            
            let valid = [...doc.files].every(file => allowedType.includes(file.type.replace(/(.*)\//g, '')), false);
            if (valid){
              delete validationErrors.value[`${doc.ref}`];
              delete validationErrors.value[`type_${doc.ref}`];
            }else{
              validationErrors.value[`type_${doc.ref}`] = true;
            }
          }
        }
      })
      if (isManualContract.value) {
        if (data_firma_cartaceo.value) {
          delete validationErrors.value.data_firma_cartaceo;
        }else {
          validationErrors.value.data_firma_cartaceo = true;
        }
      } 
    
      return !Object.keys(validationErrors.value).length;
    }

    const addFile = (ref = 'gen') => {
      if (ref == 'di') requiredDocuments.value.push({
        name:'Documento di identità',
        ref:'di',
        files:[],
        multiple:false,
        already_imported: []
      })

      if (ref == 'gen') requiredDocuments.value.push({
        name:'Altri documenti',
        ref:'gen',
        files:[],
        multiple:true,
        already_imported: []
      })
      
      if (ref == 'tg') requiredDocuments.value.push({
        name:`Titolo giustificativo`,
        ref:'tg',
        files:[],
        multiple:false,
        already_imported: []
      })
      
      if (ref == 'ft') requiredDocuments.value.push({
        name:'Fatture',
        ref:'ft',
        files:[],
        multiple:true,
        already_imported: []
      })
    }

    const isVisibleAddFile = computed(() => {
      return !requiredDocuments.value.some(doc => doc.ref == 'gen')
    })

    const deleteFile = (index) => {
      requiredDocuments.value.splice(index, 1);
    }

    // Verifica se l'oggetto cliente ha dei dati effettivi
    const hasClienteData = computed(() => {
      const cliente = props.formData.cliente;
      return !!(cliente && cliente.codfis && cliente.codfis.trim() !== '');
    });

    const getOffertaName = (id) => {
      if (!props.formData.offerte) return 'Nessuna Offerta';
      const offerta = props.formData.offerte.find(o => o.id === id);
      return offerta ? offerta.name : 'Offerta non trovata';
    };
    const selectedSpedizione = ref('')
    const selectedFrequenza = ref('Mensile')
    const getDefaultValidazioneIndirizzoSpedizione = () => ({
      called: false,
      loading: false,
      status: null,
      message: '',
      error_field: '',
      error: '',
      osm_data: null,
      payload: null,
      raw: null
    })
    const validazioneIndirizzoSpedizione = ref(getDefaultValidazioneIndirizzoSpedizione())
    const showDialogIndirizzoSpedizione = ref(false)
    const getContattoSpedizioneFromProps = () => {
      return { ...(props.formData.contatto || {}) }
    }
    const contattoSpedizioneOriginale = ref(getContattoSpedizioneFromProps())
    const contattoSpedizione = ref({...contattoSpedizioneOriginale.value})
    const cities_indirizzo_spedizione = ref([])
    const formatPayloadAddressField = (value) => {
      return (value || '').toString().trim().toUpperCase()
    }
    const getCodComuneFromIndirizzoSpedizione = (contatto) => {
      if (contatto.cod_comune) return contatto.cod_comune

      const provincia = contatto.provincia || ''
      const nomeComune = formatPayloadAddressField(contatto.nome_comune || contatto.name)
      const cities = provincia ? opzioni.getCities(provincia) : []
      const city = cities.find(city => formatPayloadAddressField(city.name) === nomeComune)

      return city ? city.id : null
    }
    const setCitiesIndirizzoSpedizione = (provincia) => {
      cities_indirizzo_spedizione.value = provincia ? opzioni.getCities(provincia) : []
    }
    const getIndirizzoSpedizioneEditFromContatto = () => {
      const contatto = contattoSpedizione.value

      return {
        toponimo: contatto.toponimo || '',
        indirizzo: contatto.indirizzo || '',
        civico: contatto.civico || '',
        comune: contatto.nome_comune || contatto.name || '',
        cod_comune: getCodComuneFromIndirizzoSpedizione(contatto),
        cap: contatto.cap || '',
        provincia: contatto.provincia || ''
      }
    }
    const indirizzoSpedizioneEdit = ref(getIndirizzoSpedizioneEditFromContatto())
    const isSpedizioneCartacea = computed(() => {
      return (selectedSpedizione.value || '').includes('Cartaceo')
    })
    const indirizzoContattoSpedizione = computed(() => {
      const contatto = contattoSpedizione.value

      return {
        toponimo: contatto.toponimo || '',
        indirizzo: contatto.indirizzo || '',
        civico: contatto.civico || '',
        cap: contatto.cap || '',
        comune: contatto.nome_comune || contatto.name || '',
        provincia: contatto.provincia || '',
        cod_comune: contatto.cod_comune || null
      }
    })
    const indirizzoContattoSpedizioneLabel = computed(() => {
      const indirizzo = indirizzoContattoSpedizione.value
      const via = [indirizzo.toponimo, indirizzo.indirizzo, indirizzo.civico].filter(Boolean).join(' ')
      const comune = [indirizzo.cap, indirizzo.comune].filter(Boolean).join(' - ')
      const provincia = indirizzo.provincia ? `(${indirizzo.provincia})` : ''

      return [via, comune, provincia].filter(Boolean).join(', ')
    })
    const getContattoSpedizionePayload = () => ({...contattoSpedizione.value})
    const canBlockAddressValidation = computed(() => {
      return Boolean(validazioneIndirizzoSpedizione.value.status === false && can_block_address.value)
    })
    const shippingAddressValidationMessage = computed(() => {
      if (validazioneIndirizzoSpedizione.value.error) {
        return validazioneIndirizzoSpedizione.value.error || 'Indirizzo di spedizione non valido.'
      }

      if (canBlockAddressValidation.value) {
        return 'Indirizzo di spedizione non valido.'
      }

      return "La fattura cartacea potrebbe non essere recapitata se l'indirizzo non é valido."
    })
    const payloadValidazioneIndirizzoSpedizione = computed(() => {
      const indirizzo = indirizzoContattoSpedizione.value

      return {
        Indirizzo: formatPayloadAddressField([indirizzo.toponimo, indirizzo.indirizzo, indirizzo.civico].filter(Boolean).join(' ')),
        Comune: formatPayloadAddressField(indirizzo.comune),
        Cap: formatPayloadAddressField(indirizzo.cap),
        Provincia: formatPayloadAddressField(indirizzo.provincia),
        Nazione: 'ITALIA'
      }
    })
    const payloadValidazioneIndirizzoSpedizioneAdvanced = computed(() => {
      const payload = payloadValidazioneIndirizzoSpedizione.value

      return {
        Indirizzo: payload.Indirizzo,
        Comune: payload.Comune,
        Cap: payload.Cap,
        Provincia: payload.Provincia
      }
    })
    const hasIndirizzoContattoSpedizione = computed(() => {
      const payload = payloadValidazioneIndirizzoSpedizione.value

      return Boolean(
        payload.Indirizzo &&
        payload.Comune &&
        payload.Cap &&
        payload.Provincia &&
        payload.Nazione
      )
    })
    const resetValidazioneIndirizzoSpedizione = () => {
      validazioneIndirizzoSpedizione.value = getDefaultValidazioneIndirizzoSpedizione()
    }
    const openDialogIndirizzoSpedizione = () => {
      indirizzoSpedizioneEdit.value = getIndirizzoSpedizioneEditFromContatto()
      setCitiesIndirizzoSpedizione(indirizzoSpedizioneEdit.value.provincia)
      resetValidazioneIndirizzoSpedizione()
      showDialogIndirizzoSpedizione.value = true
    }
    const onChangeIndirizzoSpedizioneEdit = () => {
      resetValidazioneIndirizzoSpedizione()
    }
    const onSelectedProvinciaIndirizzoSpedizione = (evt) => {
      indirizzoSpedizioneEdit.value.cod_comune = null
      indirizzoSpedizioneEdit.value.comune = ''
      setCitiesIndirizzoSpedizione(evt.value)
      resetValidazioneIndirizzoSpedizione()
    }
    const onSelectedComuneIndirizzoSpedizione = (evt) => {
      indirizzoSpedizioneEdit.value.cod_comune = evt.value
      indirizzoSpedizioneEdit.value.comune = opzioni.getNameCityById(evt.value)
      resetValidazioneIndirizzoSpedizione()
    }
    const canSaveIndirizzoSpedizione = computed(() => {
      const indirizzo = indirizzoSpedizioneEdit.value

      return Boolean(
        formatPayloadAddressField(indirizzo.toponimo) &&
        formatPayloadAddressField(indirizzo.indirizzo) &&
        formatPayloadAddressField(indirizzo.civico) &&
        formatPayloadAddressField(indirizzo.cap) &&
        formatPayloadAddressField(indirizzo.provincia) &&
        indirizzo.cod_comune
      )
    })
    const saveIndirizzoSpedizione = async () => {
      if (!canSaveIndirizzoSpedizione.value) return

      const comune = formatPayloadAddressField(indirizzoSpedizioneEdit.value.comune || opzioni.getNameCityById(indirizzoSpedizioneEdit.value.cod_comune))
      const nextContattoSpedizione = {
        ...contattoSpedizione.value,
        toponimo: formatPayloadAddressField(indirizzoSpedizioneEdit.value.toponimo),
        indirizzo: formatPayloadAddressField(indirizzoSpedizioneEdit.value.indirizzo),
        civico: formatPayloadAddressField(indirizzoSpedizioneEdit.value.civico),
        cap: formatPayloadAddressField(indirizzoSpedizioneEdit.value.cap),
        provincia: formatPayloadAddressField(indirizzoSpedizioneEdit.value.provincia),
        cod_comune: indirizzoSpedizioneEdit.value.cod_comune || null,
        nome_comune: comune,
        name: comune
      }
      contattoSpedizione.value = nextContattoSpedizione

      resetValidazioneIndirizzoSpedizione()
      showDialogIndirizzoSpedizione.value = false
      if (isSpedizioneCartacea.value) await validaIndirizzoSpedizione()
    }
    const validaIndirizzoSpedizione = async () => {
      if (!hasIndirizzoContattoSpedizione.value) {
        validazioneIndirizzoSpedizione.value = {
          ...getDefaultValidazioneIndirizzoSpedizione(),
          called: true,
          status: false,
          error_field: 'Indirizzo',
          error: 'Indirizzo di spedizione non presente o incompleto.',
          payload: payloadValidazioneIndirizzoSpedizione.value
        }
        return
      }

      const payload = payloadValidazioneIndirizzoSpedizione.value
      validazioneIndirizzoSpedizione.value.loading = true

      try {
        const advancedRes = await service.validateContactAddressAdvanced(payloadValidazioneIndirizzoSpedizioneAdvanced.value)
        const advancedData = advancedRes.items || {}

        if (advancedData.status === true) {
          validazioneIndirizzoSpedizione.value = {
            called: true,
            loading: false,
            status: true,
            message: advancedData.message || 'Indirizzo valido',
            error_field: '',
            error: '',
            osm_data: null,
            payload,
            raw: {
              advanced: advancedData,
              fallback: null
            }
          }

          return
        }

        const fallbackRes = await service.validateContactAddress(payload)
        const fallbackData = fallbackRes.items || {}

        const fallbackIsValid = fallbackData.status === true

        validazioneIndirizzoSpedizione.value = {
          called: true,
          loading: false,
          status: fallbackIsValid,
          message: fallbackIsValid ? (fallbackData.message || 'Indirizzo valido') : '',
          error_field: fallbackIsValid ? '' : (fallbackData.error_field || 'Indirizzo'),
          error: fallbackIsValid ? '' : (fallbackData.error || 'Indirizzo di spedizione non valido.'),
          osm_data: fallbackData.osm_data || null,
          payload,
          raw: {
            advanced: advancedData,
            fallback: fallbackData
          }
        }

      } finally {
        validazioneIndirizzoSpedizione.value.loading = false
      }
    }
    watch(selectedSpedizione, async (spedizione) => {
      resetValidazioneIndirizzoSpedizione()
      if ((spedizione || '').includes('Cartaceo')) await validaIndirizzoSpedizione()
    })
    const defaultSpedizioni = [
      { id: 1, name: "Mail + Cartaceo" },
      { id: 2, name: "Mail" },
      { id: 3, name: "Cartaceo" }
    ];
    const spedizioni = ref([...defaultSpedizioni]);
    const frequenze = ref([
      {id: 1, name: 'Mensile'},
      {id: 2, name: 'Bimestrale'}
    ]);
    const isManualContract = ref(false)
    const isIvaAgevolata = ref(false)
    const isCheckedDataSwitch = ref()

    const dataSwitch = ref()
    const minDataSwitch = ref()
    const maxDataSwitch = ref()


    // const date = ref(new Date());
    // const minDatePod = ref();
    // const minDatePdr = ref();
    
    // const maxDatePod = ref();
    // const maxDatePdr = ref();
    // const dataSwitchPod = ref()
    // const dataSwitchPdr = ref()
    const codice_promozionale = ref('')
    const id_promozione = ref()
    const id_cliente_promozione = ref()
    const canGoToNext = ref(true)
    const canViewInputPromo = ref()

    const setCanViewInputPromo = async () => {
      await service.CanViewInputPromo()
      .then((res) => {
        canViewInputPromo.value = res.item
      })
    }

    const verificaCodicePromozionale = async (inReset = true) => {
      if (codice_promozionale.value) {
        await service.checkCodicePromozionale(codice_promozionale.value)
        .then((res) => {
          if (!res.items.success && inReset) {
            codice_promozionale.value = ''
          }
          id_promozione.value = res.items.id_promozione
          id_cliente_promozione.value = res.items.id_cliente_promozione 
          let severity = res.items.success ? 'success' : 'error'
          let detail = res.items.msg
          toast.add({severity: severity, detail: detail, life: 5000})
          canGoToNext.value = inReset ? inReset : res.items.success
        })
      }
    }
    const checkCanGoToNext = (evt) => {     
      canGoToNext.value = evt.target.value == '' 
    }

    const canViewButtonCheckCodicePromozionale = computed(() => {
      return codice_promozionale.value != '' && codice_promozionale.value != null
    })

    const onChangeIsManualContract = () => {
      if (isManualContract.value) {
        data_firma_cartaceo.value = new Date()
        let docs_to_insert = [
          {name:'Contratto Cartaceo',ref:'ctr'}
        ]
        
        if (props.formData.pratica != null) {
          labels.value.push(`Moduli ${pratica.value}`)
          props.formData.manualRows.forEach(row => {
            docs_to_insert.push({name:`${pratica.value} ${row.POD_PDR}`,ref:row.POD_PDR})
          })
        }
        docs_to_insert.forEach(doc => {
          requiredDocuments.value.push({
            name: doc.name,
            ref: doc.ref,
            files:[],
            multiple:false,
            already_imported: []
          })
        })
      }else{
        data_firma_cartaceo.value = null
        let docs_to_delete = ['ctr']
        if (props.formData.pratica != null) {
          let index_label_moduli = labels.value.findIndex(label => label == `Moduli ${pratica.value}`)
          if (index_label_moduli != -1) labels.value.splice(index_label_moduli, 1)
          props.formData.manualRows.forEach(row => {
            docs_to_delete.push(row.POD_PDR)
          })
        }

        requiredDocuments.value = requiredDocuments.value.filter(doc => {
          return !docs_to_delete.includes(doc.ref)
        })
      }
    }

    // const setDataUtileSwitch = () => {
    //   let today = new Date();
    //   let giornoMese = today.getDate();
    //   let incremento = giornoMese <= 10 ? 1 : 2;

    //   let calcoloMeseSwitch = today.getMonth() + incremento;
    //   let meseSwitch = calcoloMeseSwitch > 12 ? calcoloMeseSwitch - 12 : calcoloMeseSwitch;
    //   let calcoloAnnoSwitch = today.getFullYear();
    //   let annoSwitch = calcoloMeseSwitch > 12 ? calcoloAnnoSwitch + 1 : calcoloAnnoSwitch;
    //   dataSwitch.value = new Date(annoSwitch, meseSwitch, 1);
    //   minDataSwitch.value = new Date(annoSwitch, meseSwitch, 1);
    //   maxDataSwitch.value = new Date(annoSwitch+1, meseSwitch-1, 1);
    // }

    return {
      loading,
      files,
      cartaceo,
      di,
      ft,
      vs,
      ctr,
      validationErrors, 
      submitted, 
      service, 
      nextPage, 
      prevPage, 
      handleFileUpload,
      handleFileNewUpload,
      allowedType,
      showModal,
      contractPreviewHidden,
      contractPreviewDialog,
      isCompletingContract,
      matrice_id,
      showPdf,
      pdfPreviews,
      contractDownloaded,
      pdfPreviewLoading,
      signatureRequested,
      signatureLoading,
      signPdf,
      forceDisableGeneraContratto,
      canGoToRiepilogo,
      typeClient,
      isDisableShowPdf,
      isDisableSignPdf,
      can_require_esign,
      props,
      is_complete_rapp,
      slides,
      requiredDocuments,
      is_pratica,
      pratica,
      note,
      isDisableInput,
      maxDate,
      data_firma_cartaceo,
      windowSize,
      onChangeDataFirma,
      addFile,
      deleteFile,
      isVisibleAddFile,
      showConfirm,
      confirmSubmission,
      getOffertaName,
      hasClienteData,
      currentUser,
      isManualContract,
      isIvaAgevolata,
      selectedSpedizione,
      isSpedizioneCartacea,
      indirizzoContattoSpedizioneLabel,
      canBlockAddressValidation,
      shippingAddressValidationMessage,
      hasIndirizzoContattoSpedizione,
      validazioneIndirizzoSpedizione,
      validaIndirizzoSpedizione,
      showDialogIndirizzoSpedizione,
      contattoSpedizione,
      indirizzoSpedizioneEdit,
      cities_indirizzo_spedizione,
      province,
      toponimi,
      openDialogIndirizzoSpedizione,
      onChangeIndirizzoSpedizioneEdit,
      onSelectedProvinciaIndirizzoSpedizione,
      onSelectedComuneIndirizzoSpedizione,
      canSaveIndirizzoSpedizione,
      saveIndirizzoSpedizione,
      selectedFrequenza,
      spedizioni,
      frequenze,
      isCheckedDataSwitch,
      verificaCodicePromozionale,
      canViewButtonCheckCodicePromozionale,
      canGoToNext,
      checkCanGoToNext,
      canViewInputPromo,
      codice_promozionale,
      // dataSwitchPod,
      // dataSwitchPdr,
      // date,
      // minDatePod,
      // maxDatePod,
      // minDatePdr,
      // maxDatePdr,
      onChangeIsManualContract,
      labels,
      can_sign_manual,
      can_insert_note,
      can_select_frequenza,
      can_select_data_switch,
      can_select_bimestrale,
      can_select_iva,
      can_select_spedizione,
      dataSwitch,
      minDataSwitch,
      maxDataSwitch,
      goToFirstStep,
      updateContratto,
      isSpedizioneCartaceaDisabled
    }
  },
}
</script>
<style>
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
}

.button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  height: 50px !important;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
  -webkit-box-shadow: 0px 10px 13px -7px #00000050, 5px 5px 15px 5px rgba(0,0,0,0); 
  box-shadow: 0px 10px 13px -7px #00000050, 5px 5px 15px 5px rgba(0,0,0,0);
}

#upload, #uploadCartaceo , #di, #vs, #ft, #ctr, .upload-file{
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 50px !important;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}

li{
  list-style-type: none;
}
</style>
<style scoped>

  @media (max-width: 400px) {
    .p-small{
      font-size: 12px !important;
    }
  }
  .p-card{
    min-width: 335px !important;
  }
  .p-dialog-mask{
    z-index: 2;
  }
  .btn-reset:hover {
    background: linear-gradient(135deg, #215159 0%, #1a7f89 100%);
    opacity: 1;
  }

  :deep(.p-button-text-wrap .p-button-label) {
    white-space: normal;
    text-align: center;
    line-height: 1.4;
  }

  .btn-equal-size {
    width: 100% !important;
    height: 100%;
    min-height: 50px;
  }

  .shipping-address-panel {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.75rem 1rem;
    width: 100%;
    padding: 0.9rem 1rem;
    border-left: 3px solid #2196F3;
    border-radius: 6px;
    background: #f8fafc;
  }

  .shipping-address-copy {
    flex: 1 1 280px;
    min-width: 0;
  }

  .shipping-address-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.5rem;
  }

  @media (max-width: 600px) {
    .shipping-address-actions {
      justify-content: flex-start;
      width: 100%;
    }
  }
</style>

<style>
.contract-navigation-blocker { position: fixed; inset: 0; z-index: 2147483646; cursor: wait; }
</style>
